export * from './sidenav';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/sidenav/index.js
// module id = 388
// module chunks = 3